const generateRandomString = (length = 10) =>
  Math.random().toString(20).substr(2, length);
const MenuSvg = require("@/assets/Menu_Svg/Menu_Svg.js");
const domain = localStorage.getItem("domain");
let allMaster = [
  "SCN_BRANCH",
  "SCN_DEPARTMENT",
  "SCN_DESIGNATION",
  "SCN_SUB_DEPARTMENT",
  "SCN_REGION",
  "SCN_PROCESS",
  "SCN_SERVICE_CATEGORY",
  "SCN_SERVICE",
  "SCN_UOM",
  "SCN_KPI_TYPE",
  "SCN_CHANNEL",
  "SCN_SUB_CHANNEL",
  "SCN_DIVISION",
  "SCN_SUB_DIVISION",
  "SCN_CATEGORY",
  "SCN_PERFORMANCE_RATING",
  "SCN_PAYROLL",
  "SCN_EMPLOYEE",
  "SCN_TARGET_TYPE",
  "SCN_STORE",
];
let CommoNMaster = [
  "SCN_BRANCH",
  "SCN_DEPARTMENT",
  "SCN_DESIGNATION",
  "SCN_SUB_DEPARTMENT",
  "SCN_REGION",
  "SCN_PROCESS",
  "SCN_EMPLOYEE",
];
let CHCKMaster = [];
let TKTMaster = ["SCN_SERVICE_CATEGORY", "SCN_SERVICE"];
let WLKMaster = ["SCN_WALKIN_OCCASION", "SCN_WALKIN_CAMPAIGN"];
let VSTMaster = ["SCN_VISIT_CUSTOMER", "SCN_VISIT_POM", "SCN_VISIT_TYPE"];
let PMSMaster = [
  "SCN_UOM",
  "SCN_KPI_TYPE",
  "SCN_CHANNEL",
  "SCN_SUB_CHANNEL",
  "SCN_DIVISION",
  "SCN_SUB_DIVISION",
  "SCN_CATEGORY",
  "SCN_PERFORMANCE_RATING",
  "SCN_TARGET_TYPE",
  "SCN_STORE",
  "SCN_PAYROLL",
];
let BPMaster = ["SCN_OBJECTIVE", "SCN_STRATEGY_GROUP"];
let FMSMaster = [
  "SCN_FMS_AMC_CANCEL_CAT",
  "SCN_FMS_AMC_TYPE",
  "SCN_FMS_AREA",
  "SCN_FMS_BUILDING_TYPE",
  "SCN_FMS_CAR_OPERATOR_MAKE",
  "SCN_FMS_CITY",
  "SCN_FMS_CLIENT_TYPE",
  "SCN_FMS_CLIENT_SUBTYPE",
  "SCN_FMS_CONTROLLER",
  "SCN_FMS_CUSTOMER_GROUP",
  "SCN_FMS_CALL_FUNCTION_TYPE",
  "SCN_FMS_DOORDRIVE_TYPE",
  "SCN_FMS_DRIVE_TYPE",
  "SCN_FMS_ESCLATION_TIME",
  "SCN_FMS_ESCLATION_PER",
  "SCN_FMS_ENCODER_MODEL",
  "SCN_FMS_ENCODER_MAKE",
  "SCN_FMS_EXPERTISE_LEVEL",
  "SCN_FMS_INVERTER_MAKE",
  "SCN_FMS_INSTRUMENT_TYPE",
  "SCN_FMS_LANDING_DISPLAY",
  "SCN_FMS_LIFT_CATEGORY",
  "SCN_FMS_LIFT_TYPE",
  "SCN_FMS_LIFT_MAKE",
  "SCN_FMS_LOCATION",
  "SCN_FMS_MACHINE_ROOM",
  "SCN_FMS_MENU_ACCESS",
  "SCN_FMS_MATERIAL",
  "SCN_FMS_MAINDRIVE_MAKE",
  "SCN_FMS_MACHGEAR_MAKE",
  "SCN_FMS_MOTOR_MAKE",
  "SCN_FMS_PAYMENT_TYPE",
  "SCN_FMS_PAYMENT_TERM",
  "SCN_FMS_RECEIPT_MODE",
  "SCN_FMS_REFNO_TYPE",
  "SCN_FMS_RENEWAL_TYPE",
  "SCN_FMS_ROUTE",
  "SCN_FMS_SCH_VISIT",
  "SCN_FMS_SERVICE",
  "SCN_FMS_SPARE_PARTS",
  "SCN_FMS_SPARE_GROUP",
  "SCN_FMS_STATE",
  "SCN_FMS_TAX",
  "SCN_FMS_TAX_CAT",
  "SCN_FMS_TEAM",
  "SCN_FMS_TICKET_CATEGORY",
  "SCN_FMS_TKT_SUBCAT",
  "SCN_FMS_PAUSE_CAT",
  "SCN_FMS_VISTI_SCHEDULE",
  "SCN_FMS_CUSTOMER_DESIGNATION",
  "SCN_FMS_CANCELLATION_REASON",
  "SCN_FMS_RECEIPT_NARRATIONS",
  "SCN_FMS_CUSTOMER_GRADE",
  "SCN_FMS_HIGHWAY_LANDING_TYPE",
  "SCN_FMS_DEDUCTIONS",
  "SCN_FMS_REASON_FOR_REQUIREMENT",
  "SCN_FMS_PRICE_MASTER",
  "SCN_FMS_MR",
  "SCN_FMS_MR_QUOTATION",
  "SCN_FMS_MR_CONTRACT",
];
let All_Strategy = [
  "SCN_HEALTH_CHECK",
  "SCN_VMOSA",
  "SCN_AOP",
  "SCN_ADVANCED_AOP",
  "SCN_TEMPLATE_BUILDER",
  "SCN_FINANCIAL_REPORT",
  "SCN_AOP_REPORTS",
  "SCN_FINANCIAL_BUSINESS_PLAN",
  "SCN_LEDGER_MAPPING",
  "SCN_WHAT_IF_SCENARIO",
  "SCN_ACTUAL",
  "SCN_BUDGET",
  "SCN_BUDGET_VS_ACTUAL",
  "SCN_RISK_ASSESSMENT",
  "SCN_KPI_BULLSEYE_NEW",
  "SCN_FINANCIAL_PERFORMANCES",
  "SCN_INDUSTRY_BENCHMARK",
];
let All_Team = [
  "SCN_ORG_CHART",
  "SCN_WORKFORCE_INTELLIGENCE",
  "SCN_PMS",
  "SCN_MY_SCORECARD",
  "SCN_LEARNING_ACADEMY",
  "SCN_TRAINING",
  "SCN_RECRUITMENT",
];
let KpiSetup = [
  "SCN_PMS",
  "SCN_PMS_SET_TARGET",
  "SCN_PMS_SET_WEIGHTAGE",
  "SCN_CUSTOMER_TARGET",
  "SCN_CUSTOMER_TARGET_REPORT",
];
let TeamKPIReports = [
  "SCN_PMS_KPI_ROLES_REPORT",
  "SCN_KPI_SUMMARY_REPORT",
  "SCN_KPI_STATUS_REPORT",
];
let All_Act = [
  // Process Design
  "SCN_RACI",
  "SCN_SOP",
  "SCN_DOA",
  "SCN_POLICIES",
  "SCN_WORKFLOW",
  "SCN_FORMS",
  "SCN_FORMS_DASHBOARD",
  // Management Systems
  "SCN_PROJECTS",
  "SCN_CRM",
  "SCN_WALKINS_MODULE",
  "SCN_WALKINS",
  "SCN_WLK_DASHBOARD",
  "SCN_WLK_REPORTS",
  "SCN_WLKN_FEEDBACK_RPRT",
  "SCN_VISITS",
  "SCN_TICKETS_MANDATES",
  "SCN_TKT_TICKETS",
  "SCN_TKT_SLA_SCORE",
  "SCN_TKT_REPORTS",
  "SCN_CHECKLIST",
  "SCN_CHCK_MY_CHECKLIST",
  "SCN_CHCK_MY_TASKS",
  "SCN_CHCK_TASK_LIST",
  "SCN_CHCK_REPORTS",
  "SCN_CHCK_DASHBOARD",
  "SCN_DMS",
  "SCN_SURVEY_MODULE",
  "SCN_SURVEY_DASHBOARD",
  "SCN_SURVEY",
  "SCN_SURVEY_REPORTS",
];
let All_Review = [
  "SCN_MEETING",
  "SCN_MEETING_DASHBOARD",
  "SCN_BUSINESS_INTELLIGENCE",
  "SCN_ANALYTICS",
  "SCN_REPORT_BUILDER",
  "SCN_INTERNAL_AUDIT",
];
let All_Reward = [
  "SCN_APPRAISAL_SET_APPRAISAL_CYCLE",
  "SCN_APPRAISAL_VIEW_APPRAISAL",
  "SCN_APPRISALTRENDREPORT",
  "SCN_INCENTIVE_POLICY",
  "SCN_INCENTIVE_SET_FREQUENCY",
  "SCN_PROMOTIONS",
];
let Strategy_OBJ = {
  id: generateRandomString(),
  name: "Strategy",
  has_children: true,
  screen_codeflag: All_Strategy,
  product_code: ["TECTALIK_PLANNING"],
  module_codeflag: ["HEALTH_CHECK", "VMOSA", "BUSINESS_PLAN", "RISK_ASSESSMENT", "BULLSEYE", "FINANCIAL_PERFORMANCE", "INDUSTRY_BENCHMARK"],
  icon: require("@/assets/svgviewer-png-output.png"),
  blue_icon: require("@/assets/blue-strategy.png"),
  svg_icon: MenuSvg.GPS_Svg,
  is_FirstLetter: true,
  children: [
    {
      id: generateRandomString(),
      name: "Health Check",
      child: true,
      product_code: ["TECTALIK_PMS"],
      has_children: false,
      screen_codeflag: ["SCN_HEALTH_CHECK"],
      module_codeflag: ["HEALTH_CHECK"],
      icon: "mdi-stethoscope",
      to: "/financial_health_check_dashboard_main",
    },
    {
      id: generateRandomString(),
      name: "VMOSA",
      child: true,
      has_children: false,
      icon: "mdi-bullseye-arrow",
      to: "/vmosa_ui",
      product_code: ["TECTALIK_PMS", "TECTALIK_PLANNING"],
      screen_codeflag: ["SCN_VMOSA"],
      module_codeflag: ["VMOSA"],
    },
    {
      id: generateRandomString(),
      name: "Business Plan",
      child: true,
      icon: "mdi-clipboard-text-outline",
      to: "/financial_business_plan",
      product_code: ["TECTALIK_PMS", "TECTALIK_PLANNING"],
      screen_codeflag: ["SCN_AOP", "SCN_ADVANCED_AOP", "SCN_TEMPLATE_BUILDER", "SCN_FINANCIAL_REPORT", "SCN_AOP_REPORTS", "SCN_FINANCIAL_BUSINESS_PLAN", "SCN_LEDGER_MAPPING", "SCN_WHAT_IF_SCENARIO", "SCN_ACTUAL", "SCN_BUDGET", "SCN_BUDGET_VS_ACTUAL"],
      module_codeflag: ["BUSINESS_PLAN"],
      // NOTE (20260715000000): Business Plan now links directly to
      // /financial_business_plan instead of expanding a submenu — all these
      // sub-pages are embedded as tabs inside Financial Business Plan itself.
      // Children kept here (commented out) in case the standalone submenu
      // needs to be restored.
      // has_children: true,
      // children: [
      //   {
      //     id: generateRandomString(),
      //     name: "Ledger Mapping",
      //     child: true,
      //     icon: "mdi-alpha-l-circle",
      //     to: "/ledger_mapping",
      //     product_code: ["TECTALIK_PLANNING"],
      //     screen_codeflag: ["SCN_LEDGER_MAPPING"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //   },
      //   {
      //     id: generateRandomString(),
      //     name: "What-If Scenario",
      //     child: true,
      //     icon: "mdi-alpha-w-circle",
      //     to: "/what_if_landing",
      //     product_code: ["TECTALIK_PLANNING"],
      //     screen_codeflag: ["SCN_WHAT_IF_SCENARIO"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //   },
      //   {
      //     id: generateRandomString(),
      //     name: "Actual",
      //     child: true,
      //     icon: "mdi-alpha-a-circle",
      //     to: "/actual_new",
      //     screen_code: ["CREATE_MASTERS"],
      //     product_code: ["TECTALIK_PMS"],
      //     screen_codeflag: ["SCN_ACTUAL"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //   },
      //   {
      //     id: generateRandomString(),
      //     name: "Budget",
      //     child: true,
      //     icon: "mdi-alpha-b-circle",
      //     to: "/budget_new",
      //     screen_code: ["CREATE_MASTERS"],
      //     product_code: ["TECTALIK_PMS"],
      //     screen_codeflag: ["SCN_BUDGET"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //   },
      //   {
      //     id: generateRandomString(),
      //     name: "Budget Vs Actual",
      //     child: true,
      //     icon: "mdi-alpha-b-circle",
      //     to: "/budget_vs_actual_reports",
      //     screen_code: ["CREATE_MASTERS"],
      //     product_code: ["TECTALIK_PMS"],
      //     screen_codeflag: ["SCN_BUDGET_VS_ACTUAL"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //   },
      //   {
      //     id: generateRandomString(),
      //     name: "Advanced AOP",
      //     child: true,
      //     has_children: true,
      //     icon: "mdi-chart-bar",
      //     product_code: ["TECTALIK_PLANNING"],
      //     screen_codeflag: ["SCN_AOP", "SCN_ADVANCED_AOP", "SCN_TEMPLATE_BUILDER", "SCN_FINANCIAL_REPORT", "SCN_AOP_REPORTS"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //     children: [
      //      {
      //         id: generateRandomString(),
      //         icon: "mdi-alpha-c-circle",
      //         name: "AOP",
      //         to: "/aop",
      //         child: true,
      //         product_code: ["TECTALIK_PLANNING"],
      //         underline: false,
      //         screen_codeflag: ["SCN_AOP"],
      //         module_codeflag: ["BUSINESS_PLAN"],
      //       },
      //       {
      //         id: generateRandomString(),
      //         icon: "mdi-alpha-c-circle",
      //         name: "Advanced AOP",
      //         to: "/aop_ui_2",
      //         child: true,
      //         product_code: ["TECTALIK_PLANNING"],
      //         underline: false,
      //         screen_codeflag: ["SCN_ADVANCED_AOP"],
      //         module_codeflag: ["BUSINESS_PLAN"],
      //       },
      //       {
      //         id: generateRandomString(),
      //         child: true,
      //         icon: "mdi-alpha-f-circle",
      //         name: "Template Builder",
      //         to: "/field_creation_template",
      //         product_code: ["TECTALIK_PLANNING"],
      //         screen_codeflag: ["SCN_TEMPLATE_BUILDER"],
      //         module_codeflag: ["BUSINESS_PLAN"],
      //       },
      //       {
      //         id: generateRandomString(),
      //         name: "Financial Report",
      //         child: true,
      //         icon: "mdi-alpha-w-circle",
      //         to: "/what_if_landing_dynamic",
      //         product_code: ["TECTALIK_PLANNING"],
      //         screen_codeflag: ["SCN_FINANCIAL_REPORT"],
      //         module_codeflag: ["BUSINESS_PLAN"],
      //       },
      //       {
      //         id: generateRandomString(),
      //         icon: "mdi-alpha-c-circle",
      //         name: "Reports",
      //         to: "/coa_landing",
      //         child: true,
      //         product_code: ["TECTALIK_PLANNING"],
      //         underline: false,
      //         screen_codeflag: ["SCN_AOP_REPORTS"],
      //         module_codeflag: ["BUSINESS_PLAN"],
      //       },
      //     ],
      //   },
      //   {
      //     id: generateRandomString(),
      //     name: "Financial Business Plan",
      //     child: true,
      //     icon: "mdi-finance",
      //     to: "/financial_business_plan",
      //     product_code: ["TECTALIK_PLANNING"],
      //     screen_codeflag: ["SCN_FINANCIAL_BUSINESS_PLAN"],
      //     module_codeflag: ["BUSINESS_PLAN"],
      //   },
      // ],
    },
    {
      id: generateRandomString(),
      name: "Risk Assessment",
      child: true,
      icon: "mdi-shield-alert-outline",
      to: "/risk_assessment",
      product_code: ["TECTALIK_PLANNING"],
      screen_codeflag: ["SCN_RISK_ASSESSMENT"],
      module_codeflag: ["RISK_ASSESSMENT"],
    },
    {
      id: generateRandomString(),
      name: "Bullseye",
      child: true,
      product_code: ["TECTALIK_PMS"],
      has_children: false,
      to: "/kpi_bullseye_new",
      screen_codeflag: ["SCN_KPI_BULLSEYE_NEW"],
      module_codeflag: ["BULLSEYE"],
      icon: "mdi-bullseye-arrow",
    },
    {
      id: generateRandomString(),
      name: "Financial Performance",
      title: "Financial Performance",
      child: true,
      icon: "mdi-chart-line",
      to: "/financial_performance_dashboard",
      screen_code: ["SCN_FINANCIAL_PERFORMANCES"],
      product_code: ["TECTALIK_PLANNING"],
      underline: false,
      screen_codeflag: ["SCN_FINANCIAL_PERFORMANCES"],
      module_codeflag: ["FINANCIAL_PERFORMANCE"],
    },
    // {
    //   id: generateRandomString(),
    //   name: "Industry Benchmark",
    //   title: "Industry Benchmark",
    //   child: true,
    //   icon: "mdi-chart-bar",
    //   to: "/industry_benchmark_dashboard",
    //   screen_code: ["SCN_INDUSTRY_BENCHMARK"],
    //   product_code: ["TECTALIK_PLANNING"],
    //   underline: false,
    //   iscommontoshow: true,
    //   screen_codeflag: ["SCN_INDUSTRY_BENCHMARK"],
    //   module_codeflag: ["INDUSTRY_BENCHMARK"],
    // },
  ],
};
let Team_OBJ = {
  id: generateRandomString(),
  icon: require("@/assets/team-png.png"),
  blue_icon: require("@/assets/blue-team.png"),
  svg_icon: MenuSvg.Profile2_Svg,
  name: "Team",
  has_children: true,
  screen_codeflag: All_Team,
  product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
  module_codeflag: ["ORGANIZATION_CHART", "WORKFORCE_INTELLIGENCE", "PMS", "MY_SCORECARD", "LEARNING_ACADEMY", "TRAINING", "RECRUITMENT"],
  is_FirstLetter: true,
  children: [
    {
      id: generateRandomString(),
      icon: "mdi-family-tree",
      name: "Organization Chart",
      has_children: false,
      to: "/org_chart_dashboard",
      product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      screen_codeflag: ["SCN_ORG_CHART"],
      module_codeflag: ["ORGANIZATION_CHART"],
    },
    {
      id: generateRandomString(),
      has_children: false,
      icon: "mdi-chart-timeline-variant",
      name: "Workforce Intelligence",
      to: "/executive-summary",
      product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      screen_codeflag: ["SCN_WORKFORCE_INTELLIGENCE"],
      module_codeflag: ["WORKFORCE_INTELLIGENCE"],
    },
    {
      id: generateRandomString(),
      icon: "mdi-star-circle",
      name: "PMS",
      to: "/pms",
      has_children: false,
      product_code: ["TECTALIK_PMS"],
      screen_codeflag: ["SCN_PMS"],
      module_codeflag: ["PMS"],
    },
    {
      id: generateRandomString(),
      icon: "mdi-account-circle",
      name: "My Scorecard",
      to: "/profile_dashboard",
      has_children: false,
      product_code: ["TECTALIK_PMS"],
      screen_codeflag: ["SCN_MY_SCORECARD"],
      module_codeflag: ["MY_SCORECARD"],
    },
    {
      id: generateRandomString(),
      icon: "mdi-school",
      name: "Learning Academy",
      to: "/learning_academy",
      has_children: false,
      product_code: ["TECTALIK_CHCK"],
      screen_codeflag: ["SCN_LEARNING_ACADEMY"],
      module_codeflag: ["LEARNING_ACADEMY"],
    },
    {
      id: generateRandomString(),
      icon: "mdi-book-open-variant",
      name: "Training",
      to: "/training_dashboard",
      has_children: false,
      product_code: ["TECTALIK_CHCK"],
      screen_codeflag: ["SCN_TRAINING"],
      module_codeflag: ["TRAINING"],
    },
    {
      id: generateRandomString(),
      icon: "mdi-magnify",
      name: "Recruitment",
      to: "/recruitment",
      has_children: false,
      product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      screen_codeflag: ["SCN_RECRUITMENT"],
      module_codeflag: ["RECRUITMENT"],
    },
  ],
};
let ACT_Child_ARR_1 = [
  {
    id: generateRandomString(),
    name: "Process Design",
    child: true,
    has_children: true,
    isAccordion: true,
    icon: "mdi-sitemap",
    product_code: ["TECTALIK_CHCK", "TECTALIK_PMS", "TECTALIK_VISITS"],
    screen_codeflag: ["SCN_RACI", "SCN_SOP", "SCN_DOA", "SCN_POLICIES", "SCN_WORKFLOW", "SCN_FORMS", "SCN_FORMS_DASHBOARD"],
    module_codeflag: ["RACI", "SOP", "DOA", "POLICIES", "WORK_FLOW", "FORMS"],
    children: [
      {
        id: generateRandomString(),
        name: "SOP",
        child: true,
        icon: "mdi-book-open-outline",
        to: "/sop-builder/dashboard",
        has_children: false,
        product_code: ["TECTALIK_VISITS"],
        screen_codeflag: ["SCN_SOP"],
        module_codeflag: ["SOP"],
      },
      {
        id: generateRandomString(),
        name: "DOA",
        child: true,
        icon: "mdi-lock-outline",
        to: "/doa/dashboard",
        has_children: false,
        product_code: ["TECTALIK_VISITS"],
        screen_codeflag: ["SCN_DOA"],
        module_codeflag: ["DOA"],
      },
      {
        id: generateRandomString(),
        name: "Policies",
        child: true,
        icon: "mdi-file-document-outline",
        to: "/policies_dashboard",
        has_children: false,
        product_code: ["TECTALIK_CHCK"],
        screen_codeflag: ["SCN_POLICIES"],
        module_codeflag: ["POLICIES"],
      },
      {
        id: generateRandomString(),
        name: "Work Flow",
        icon: "mdi-lightning-bolt",
        to: "/work_flow_dashboard",
        has_children: false,
        product_code: ["TECTALIK_CHCK"],
        screen_codeflag: ["SCN_WORKFLOW"],
        module_codeflag: ["WORK_FLOW"],
      },
      domain === "naga"
        ? {
            id: generateRandomString(),
            icon: "mdi-form-select",
            name: "Forms",
            has_children: true,
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_FORMS"],
            module_codeflag: ["FORMS"],
            children: [
              {
                id: generateRandomString(),
                icon: "mdi-form-select",
                name: "Forms",
                to: "/forms_master",
                has_children: false,
                product_code: ["TECTALIK_CHCK"],
                screen_codeflag: ["SCN_FORMS"],
                module_codeflag: ["FORMS"],
              },
              {
                id: generateRandomString(),
                icon: "mdi-view-dashboard-outline",
                name: "Forms Dashboard",
                to: "/Forms_Dashboard",
                has_children: false,
                product_code: ["TECTALIK_CHCK"],
                screen_codeflag: ["SCN_FORMS_DASHBOARD"],
                module_codeflag: ["FORMS"],
              },
            ],
          }
        : {
            id: generateRandomString(),
            icon: "mdi-form-select",
            name: "Forms",
            to: "/Forms_Dashboard",
            has_children: false,
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_FORMS_DASHBOARD"],
            module_codeflag: ["FORMS"],
          },
      domain === "naga"
        ? { id: generateRandomString(), name: "Checklist", icon: "mdi-checkbox-marked-circle-outline", has_children: true, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHECKLIST", "SCN_CHCK_MY_CHECKLIST", "SCN_CHCK_MY_TASKS", "SCN_CHCK_TASK_LIST", "SCN_CHCK_REPORTS", "SCN_CHCK_DASHBOARD"], module_codeflag: ["CHECKLIST"], children: [
            { id: generateRandomString(), icon: "mdi-clipboard-edit", name: "My Checklist", to: "/checklist_new", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHCK_MY_CHECKLIST"], module_codeflag: ["CHECKLIST"] },
            { id: generateRandomString(), icon: "mdi-alpha-t-box", name: "My Tasks", to: "/myTasks", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHCK_MY_TASKS"], module_codeflag: ["CHECKLIST"] },
            { id: generateRandomString(), icon: "mdi-format-list-checks", name: "Task List", to: "/show_list", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHCK_TASK_LIST"], module_codeflag: ["CHECKLIST"] },
            { id: generateRandomString(), icon: "mdi-alpha-r-box", name: "Reports", to: "/showlist_all_report", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHCK_REPORTS"], module_codeflag: ["CHECKLIST"] },
            { id: generateRandomString(), icon: "mdi-clipboard-edit", name: "Checklist Dashboard", to: "/checklist_dashboard", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHCK_DASHBOARD"], module_codeflag: ["CHECKLIST"] },
          ] }
        : { id: generateRandomString(), name: "Checklist", icon: "mdi-checkbox-marked-circle-outline", to: "/checklist_dashboard", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_CHCK_DASHBOARD"], module_codeflag: ["CHECKLIST"] },
    ],
  },
];
let ACT_Child_ARR_2 = [
  {
    id: generateRandomString(),
    name: "Management Systems",
    child: true,
    has_children: true,
    isAccordion: true,
    icon: "mdi-cog-outline",
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS", "TECTALIK_SURVEY", "TECTALIK_WLK", "TECTALIK_VISITS"],
    screen_codeflag: ["SCN_PROJECTS", "SCN_CRM", "SCN_WALKINS_MODULE", "SCN_WALKINS", "SCN_WLK_DASHBOARD", "SCN_WLK_REPORTS", "SCN_WLKN_FEEDBACK_RPRT", "SCN_VISITS", "SCN_TICKETS_MANDATES", "SCN_TKT_TICKETS", "SCN_TKT_SLA_SCORE", "SCN_TKT_REPORTS", "SCN_CHECKLIST", "SCN_CHCK_MY_CHECKLIST", "SCN_CHCK_MY_TASKS", "SCN_CHCK_TASK_LIST", "SCN_CHCK_REPORTS", "SCN_CHCK_DASHBOARD", "SCN_DMS", "SCN_SURVEY_MODULE", "SCN_SURVEY_DASHBOARD", "SCN_SURVEY", "SCN_SURVEY_REPORTS"],
    module_codeflag: ["PROJECTS", "CRM", "WALKIN", "VISITS", "TICKETS", "CHECKLIST", "DMS", "SURVEY"],
    children: [
      { id: generateRandomString(), name: "Projects", icon: "mdi-briefcase-outline", to: "/project_management_v2", has_children: false, product_code: ["TECTALIK_PMS"], screen_codeflag: ["SCN_PROJECTS"], module_codeflag: ["PROJECTS"] },
      { id: generateRandomString(), name: "CRM", icon: "mdi-handshake-outline", to: "/crm", has_children: false, product_code: ["TECTALIK_PMS"], screen_codeflag: ["SCN_CRM"], module_codeflag: ["CRM"] },
      domain === "naga"
        ? { id: generateRandomString(), name: "Walkin", icon: "mdi-walk", has_children: true, product_code: ["TECTALIK_WLK"], screen_codeflag: ["SCN_WALKINS_MODULE", "SCN_WALKINS", "SCN_WLK_DASHBOARD", "SCN_WLK_REPORTS", "SCN_WLKN_FEEDBACK_RPRT"], module_codeflag: ["WALKIN"], children: [
            { id: generateRandomString(), name: "Walkins", icon: "mdi-alpha-w-circle", to: "/walkin/landing", has_children: false, product_code: ["TECTALIK_WLK"], screen_codeflag: ["SCN_WALKINS"], module_codeflag: ["WALKIN"] },
            { id: generateRandomString(), name: "Dashboard", icon: "mdi-monitor-dashboard", to: "/walkins_dashboard_new_module", has_children: false, product_code: ["TECTALIK_WLK"], screen_codeflag: ["SCN_WLK_DASHBOARD"], module_codeflag: ["WALKIN"] },
            { id: generateRandomString(), name: "Reports", icon: "mdi-alpha-r-circle", to: "/walkins/reports", has_children: false, product_code: ["TECTALIK_WLK"], screen_codeflag: ["SCN_WLK_REPORTS"], module_codeflag: ["WALKIN"] },
            { id: generateRandomString(), name: "Feedback Reports", icon: "mdi-alpha-r-circle", to: "/feedback/reports", has_children: false, product_code: ["TECTALIK_WLK"], screen_codeflag: ["SCN_WLKN_FEEDBACK_RPRT"], module_codeflag: ["WALKIN"] },
          ] }
        : { id: generateRandomString(), name: "Walkin", icon: "mdi-walk", to: "/walkins_dashboard_new_module", has_children: false, product_code: ["TECTALIK_WLK"], screen_codeflag: ["SCN_WLK_DASHBOARD"], module_codeflag: ["WALKIN"] },
      { id: generateRandomString(), name: "Visits", icon: "mdi-map-marker-outline", to: "/visits_dashboard", has_children: false, product_code: ["TECTALIK_VISITS"], screen_codeflag: ["SCN_VISITS"], module_codeflag: ["VISITS"] },
      domain === "naga"
        ? { id: generateRandomString(), name: "Tickets", icon: "mdi-ticket-outline", has_children: true, product_code: ["TECTALIK_TKT"], screen_codeflag: ["SCN_TICKETS_MANDATES", "SCN_TKT_TICKETS", "SCN_TKT_SLA_SCORE", "SCN_TKT_REPORTS"], module_codeflag: ["TICKETS"], children: [
            { id: generateRandomString(), name: "Tickets", icon: "mdi-clipboard-edit", to: "/ticket", has_children: false, product_code: ["TECTALIK_TKT"], screen_codeflag: ["SCN_TKT_TICKETS"], module_codeflag: ["TICKETS"] },
            { id: generateRandomString(), name: "SLA Score", icon: "mdi-alpha-s-box", to: "/SlaScore", has_children: false, product_code: ["TECTALIK_TKT"], screen_codeflag: ["SCN_TKT_SLA_SCORE"], module_codeflag: ["TICKETS"] },
            { id: generateRandomString(), name: "Reports", icon: "mdi-alpha-r-box", to: "/tickets_report", has_children: false, product_code: ["TECTALIK_TKT"], screen_codeflag: ["SCN_TKT_REPORTS"], module_codeflag: ["TICKETS"] },
            { id: generateRandomString(), name: "Mandate Dashboard", icon: "mdi-view-dashboard-outline", to: "/mandate_board_dashboard", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_TICKETS_MANDATES"], module_codeflag: ["TICKETS"] },
          ] }
        : { id: generateRandomString(), name: "Tickets", icon: "mdi-ticket-outline", to: "/mandate_board_dashboard", has_children: false, product_code: ["TECTALIK_CHCK"], screen_codeflag: ["SCN_TICKETS_MANDATES"], module_codeflag: ["TICKETS"] },
      { id: generateRandomString(), name: "DMS", icon: "mdi-folder-outline", to: "/dms_dashboard", has_children: false, product_code: ["TECTALIK_SURVEY"], screen_codeflag: ["SCN_DMS"], module_codeflag: ["DMS"] },
      domain === "naga"
        ? { id: generateRandomString(), name: "Survey", icon: "mdi-poll", has_children: true, product_code: ["TECTALIK_SURVEY"], screen_codeflag: ["SCN_SURVEY_MODULE", "SCN_SURVEY_DASHBOARD", "SCN_SURVEY", "SCN_SURVEY_REPORTS"], module_codeflag: ["SURVEY"], children: [
            { id: generateRandomString(), name: "Survey Dashboard", icon: "mdi-monitor-dashboard", to: "/survey_dashboard", has_children: false, product_code: ["TECTALIK_SURVEY"], screen_codeflag: ["SCN_SURVEY_DASHBOARD"], module_codeflag: ["SURVEY"] },
            { id: generateRandomString(), name: "Survey", icon: "mdi-poll", to: "/survey", has_children: false, product_code: ["TECTALIK_SURVEY"], screen_codeflag: ["SCN_SURVEY"], module_codeflag: ["SURVEY"] },
            { id: generateRandomString(), name: "Reports", icon: "mdi-alpha-r-circle", to: "/survey_reports", has_children: false, product_code: ["TECTALIK_SURVEY"], screen_codeflag: ["SCN_SURVEY_REPORTS"], module_codeflag: ["SURVEY"] },
          ] }
        : { id: generateRandomString(), name: "Survey", icon: "mdi-poll", to: "/survey_dashboard", has_children: false, product_code: ["TECTALIK_SURVEY"], screen_codeflag: ["SCN_SURVEY_DASHBOARD"], module_codeflag: ["SURVEY"] },
    ],
  },
];
let Review_OBJ = {
  id: generateRandomString(),
  icon: require("@/assets/review-png.png"),
  blue_icon: require("@/assets/blue-review.png"),
  name: "Review",
  has_children: true,
  screen_code: ["CREATE_MASTERS"],
  svg_icon: MenuSvg.ClipBoardCopy_Svg,
  product_code: ["TECTALIK_ANALYTICS"],
  screen_codeflag: All_Review,
  module_codeflag: ["REVIEW_MEETING", "BUSINESS_INTELLIGENCE", "ANALYTICS", "REPORT_BUILDER", "INTERNAL_AUDIT"],
  is_FirstLetter: true,
  children: [
    {
      id: generateRandomString(),
      name: "Review Meeting",
      child: true,
      has_children: true,
      icon: "mdi-calendar-check",
      product_code: ["TECTALIK_CHCK"],
      screen_codeflag: ["SCN_MEETING", "SCN_MEETING_DASHBOARD"],
      module_codeflag: ["REVIEW_MEETING"],
      children: [
        {
          id: generateRandomString(),
          icon: "mdi-calendar-check",
          name: "Meeting",
          to: "/meetings_new",
          has_children: false,
          product_code: ["TECTALIK_CHCK"],
          screen_codeflag: ["SCN_MEETING"],
          module_codeflag: ["REVIEW_MEETING"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-view-dashboard",
          name: "Meeting Dashboard",
          to: "/meeting_dashboard_new",
          has_children: false,
          product_code: ["TECTALIK_CHCK"],
          screen_codeflag: ["SCN_MEETING_DASHBOARD"],
          module_codeflag: ["REVIEW_MEETING"],
        },
      ],
    },
      {
      id: generateRandomString(),
      icon: "mdi-chart-line",
      name: "Business Intelligence",
      to: "/common-analytics/business_intelligence",
      has_children: false,
      product_code: ["TECTALIK_ANALYTICS"],
      screen_codeflag: ["SCN_BUSINESS_INTELLIGENCE"],
      module_codeflag: ["BUSINESS_INTELLIGENCE"],
    },
       {
      id: generateRandomString(),
      icon: "mdi-google-analytics",
      name: "Analytics",
      to: "/kpi_bots",
      has_children: false,
      product_code: ["TECTALIK_ANALYTICS"],
      screen_codeflag: ["SCN_ANALYTICS"],
      module_codeflag: ["ANALYTICS"],
    },
    // {
    //   id: generateRandomString(),
    //   name: "Report Builder",
    //   icon: "mdi-file-document-edit",
    //   to: "/report_builder_ui",
    //   has_children: false,
    //   product_code: ["TECTALIK_ANALYTICS"],
    //   screen_codeflag: ["SCN_REPORT_BUILDER"],
    //   module_codeflag: ["REPORT_BUILDER"],
    // },
    {
      id: generateRandomString(),
      name: "Internal Audit",
      child: true,
      has_children: false,
      icon: "mdi-shield-search",
      to: "/audit_module",
      product_code: ["TECTALIK_CHCK"],
      screen_codeflag: ["SCN_INTERNAL_AUDIT"],
      module_codeflag: ["INTERNAL_AUDIT"],
    },
  ],
};
let Reward_OBJ = {
  id: generateRandomString(),
  name: "Reward",
  icon: require("@/assets/reward-png.png"),
  blue_icon: require("@/assets/blue-reward.png"),
  svg_icon: MenuSvg.Cup_Svg,
  has_children: true,
  screen_code: ["SCN_REWARDS"],
  product_code: ["TECTALIK_PMS"],
  underline: true,
  screen_codeflag: ["SCN_APPRAISAL", "SCN_REWARDS"],
  module_codeflag: ["APPRAISAL", "REWARDS"],
  is_FirstLetter: true,
  children: [
    {
      id: generateRandomString(),
      icon: "mdi-star-circle",
      name: "Appraisal",
      to: "/promotions",
      screen_code: ["SCN_APPRAISAL"],
      has_children: false,
      product_code: ["TECTALIK_PMS"],
      screen_codeflag: ["SCN_APPRAISAL"],
      module_codeflag: ["APPRAISAL"],
    },
    {
      id: generateRandomString(),
      has_children: false,
      onlytextviews: false,
      svg_icon: MenuSvg.Cup_Svg,
      icon: "mdi-trophy-award",
      name: "Rewards",
      to: "/rewards_dashboard",
      product_code: ["TECTALIK_PMS"],
      screen_codeflag: ["SCN_REWARDS"],
      module_codeflag: ["REWARDS"],
    },
  ],
};
let Master_Child_ARR_1 = [
  {
    id: generateRandomString(),
    icon: "mdi-view-dashboard-outline",
    to: "/masters_dashboard",
    name: "Masters Dashboard",
    has_children: false,
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS", "TECTALIK_PLANNING", "TECTALIK_VISITS"],
    screen_codeflag: ["SCN_MASTERS_DASHBOARD"],
    module_codeflag: ["MASTERS"],
  },
];
let Master_Child_ARR_2 = [
];
let SETTINGS_Child_ARR_1 = [
  {
    id: generateRandomString(),
    name: "Global",
    child: true,
    icon: "mdi-monitor-dashboard",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    has_children: true,
    screen_codeflag: [
      "SCN_HOLIDAY",
      "SCN_WEEKOFF",
      "SCN_ROLE",
      "SCN_SCENARIOS",
      "SCN_MAIL_CONFIGURATION",
      "SCN_TKT_CMP_SLAB",
    ],
    module_codeflag: ["SETTINGS"],
    children: [
      {
        id: generateRandomString(),
        name: "Holiday",
        child: true,
        icon: "mdi-alpha-h-circle",
        to: "/holiday",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        screen_codeflag: ["SCN_HOLIDAY"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Weekoff",
        child: true,
        icon: "mdi-alpha-w-circle",
        to: "/weekoff",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        screen_codeflag: ["SCN_WEEKOFF"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Role",
        child: true,
        icon: "mdi-alpha-r-circle",
        to: "/role",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        screen_codeflag: ["SCN_ROLE"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Mail Configuration",
        child: true,
        icon: "mdi-email-edit ",
        to: "/esclation",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        underline: false,
        screen_codeflag: ["SCN_MAIL_CONFIGURATION"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Slab",
        child: true,
        icon: "mdi-alpha-s-circle",
        to: "/slab",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        underline: false,
        screen_codeflag: ["SCN_SLAB"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Field Settings",
        child: true,
        icon: "mdi-alpha-f-circle",
        to: "/employee_field_setting",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        screen_codeflag: ["SCN_FIELD_SETTINGS"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Common Settings",
        child: true,
        icon: "mdi-alpha-r-circle",
        to: "/common_settings",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        screen_codeflag: ["SCN_COMMON_SETTINGS"],
        module_codeflag: ["SETTINGS"],
      },
    ],
  },
  {
    id: generateRandomString(),
    name: "Performance",
    child: true,
    icon: "mdi-monitor-dashboard",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_PMS"],
    has_children: true,
    screen_codeflag: [
      "SCN_PMS_RATING_SETTING",
      "SCN_PMS_PRFMNC_RATING_SETTING",
    ],
    module_codeflag: ["SETTINGS"],
    children: [
      {
        id: generateRandomString(),
        name: "Appraisal Score",
        child: true,
        icon: "mdi-alpha-a-circle",
        to: "/rating_setting",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_APPRAISAL_SCORE"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Base Performance",
        child: true,
        icon: "mdi-alpha-b-circle",
        to: "/base_performance",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_BASE_PERFORMANCE"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Scorecard",
        child: true,
        icon: "mdi-alpha-s-circle",
        to: "/calc_settings",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_SCORECARD_SETTING"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "KPI Config",
        child: true,
        icon: "mdi-alpha-k-circle",
        to: "/detailed_kpi_config",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_KPI_CONFIG"],
        module_codeflag: ["SETTINGS"],
      },
    ],
  },
  {
    id: generateRandomString(),
    name: "Dashboard",
    child: true,
    icon: "mdi-monitor-dashboard",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_PMS"],
    has_children: true,
    screen_codeflag: [
      "SCN_PMS_EMPLOYEE_DASHBOARD",
    ],
    module_codeflag: ["SETTINGS"],
    children: [
      {
        id: generateRandomString(),
        name: "Employee Dashboard",
        child: true,
        icon: "mdi-alpha-a-circle",
        to: "/employeedashboard",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_PMS_EMPLOYEE_DASHBOARD"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "CEO Dashboard",
        child: true,
        icon: "mdi-alpha-a-circle",
        to: "/CEO_DashBoard",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_PMS_CEO_DASH"],
        module_codeflag: ["SETTINGS"],
      },
    ]
  },
  {
    id: generateRandomString(),
    name: "Walkins",
    child: true,
    icon: "mdi-monitor-dashboard",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_WLK"],
    has_children: true,
    screen_codeflag: [
      "SCN_WLKN_MANAGER_SETTING",
      "SCN_WLKN_SALESMAN_SETTING",
      "SCN_WLKN_FEEDBACK",
    ],
    module_codeflag: ["SETTINGS"],
    children: [
      {
        id: generateRandomString(),
        name: "Feedback",
        child: true,
        icon: "mdi-alpha-f-circle ",
        to: "/walkin/feedback",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_WLK"],
        screen_codeflag: ["SCN_WLKN_FEEDBACK"],
        module_codeflag: ["WALKINS"],
      },
      {
        id: generateRandomString(),
        name: "Salesman Setting",
        child: true,
        icon: "mdi-alpha-s-circle",
        to: "/sales_landing",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_WLK"],
        screen_codeflag: ["SCN_WLKN_SALESMAN_SETTING"],
        module_codeflag: ["SETTINGS"],
      },
      {
        id: generateRandomString(),
        name: "Manager Setting",
        child: true,
        icon: "mdi-alpha-m-circle",
        to: "/designation_setting",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_WLK"],
        screen_codeflag: ["SCN_WLKN_MANAGER_SETTING"],
        module_codeflag: ["SETTINGS"],
      },
    ],
  },
  {
    id: generateRandomString(),
    name: "FMS",
    child: true,
    icon: "mdi-monitor-dashboard",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_FMS"],
    has_children: true,
    screen_codeflag: [
      "SCN_FMS_POLICY_DEF",
      "SCN_FMS_TICKET_DEF",
      "SCN_FMS_TICKETS",
    ],
    module_codeflag: ["SETTINGS"],
    product_gate: true,
    product_only: true,
    children: [
      {
        id: generateRandomString(),
        name: "Policy Definition",
        child: true,
        icon: "mdi-alpha-f-circle ",
        to: "/policy_definition",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_POLICY_DEF"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        name: "Ticket Definition",
        child: true,
        icon: "mdi-alpha-t-circle ",
        to: "/TicketDefinition",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_TICKET_DEF"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-a-circle",
        name: "Approval List",
        to: "/approval_list",
        child: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_APPROVAL_LIST"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-d-circle",
        name: "Dashboard Roles",
        to: "/fms_dashboard_roles",
        child: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_DASHBOARD_ROLES"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-d-circle",
        name: "Dashboard",
        to: "/fms_dashboard",
        child: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_DASHBOARD"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-t-circle",
        name: "Terms",
        to: "/terms_and_conditions",
        child: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_TERMS"],
        module_codeflag: ["SETTINGS"],
      },
    ],
  },
  {
    id: generateRandomString(),
    has_children: false,
    onlytextviews: false,
    name: "Health Check Settings",
    to: "/health_check_config_landing",
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    underline: false,
    screen_codeflag: ["SCN_HEALTH_CHECK_SETTINGS"],
    module_codeflag: ["COMMON"],
  },
  {
    id: generateRandomString(),
    name: "Common Analytics",
    child: true,
    icon: "mdi-chart-box-multiple",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_ANALYTICS"],
    has_children: true,
    screen_codeflag: ["SCN_COMMON_ANALYTICS"],
    module_codeflag: ["SETTINGS"],
    children: [
      {
        id: generateRandomString(),
        name: "KPI Rights",
        child: true,
        icon: "mdi-account-key",
        to: "/common-analytics/kpiRights",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_ANALYTICS"],
        screen_codeflag: ["SCN_KPI_RIGHTS"],
        module_codeflag: ["SETTINGS"],
      },
    ],
  },
  {
    id: generateRandomString(),
    has_children: false,
    onlytextviews: false,
    name: "Media Page Config",
    to: "/media_page_config_landing",
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    underline: false,
    screen_codeflag: ["SCN_MEDIA_PAGE_CONFIG"],
    module_codeflag: ["COMMON"],
  },
];

let SETTINGS_Child_ARR_2 = [
];
let TopMenuList = [
  { ...Strategy_OBJ },
  { ...Team_OBJ },
  {
    id: generateRandomString(),
    name: "Activate",
    icon: require("@/assets/act-png.png"),
    blue_icon: require("@/assets/blue-act.png"),
    svg_icon: MenuSvg.Flash_Svg,
    product_code: [
      "TECTALIK_CHCK",
      "TECTALIK_TKT",
      "TECTALIK_SURVEY",
      "TECTALIK_VISITS",
      "TECTALIK_WLK",
    ],
    has_children: true,
    screen_codeflag: All_Act,
    module_codeflag: ["RACI", "SOP", "DOA", "POLICIES", "WORK_FLOW", "FORMS", "PROJECTS", "CRM", "WALKIN", "VISITS", "TICKETS", "CHECKLIST", "DMS", "SURVEY"],
    is_FirstLetter: true,
    twoColumnChildren: true,
    children: [...ACT_Child_ARR_1, ...ACT_Child_ARR_2],
  },
  { ...Review_OBJ },
  { ...Reward_OBJ },
];
let BottonLeftMenuList = [
];
let BottonRightMenuList = [
  {
    id: generateRandomString(),
    has_children: false,
    onlytextviews: false,
    svg_icon: MenuSvg.Library_SVG,
    icon: require("@/assets/library-png.png"),
    blue_icon: require("@/assets/blue-library.png"),
    name: "Library",
    to: "/checklist_Template_page",
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    underline: false,
    screen_codeflag: ["SCN_LIBRARY"],
    module_codeflag: ["LIBRARY"],
  },
  
{
  id: generateRandomString(),
  name: "Masters",
  icon: require("@/assets/masters-png.png"),
  blue_icon: require("@/assets/blue-masters.png"),
  svg_icon: MenuSvg._3DCube_Svg,
  screen_code: ["SCN_MASTERS"],
  product_code: [
    "TECTALIK_CHCK",
    "TECTALIK_TKT",
    "TECTALIK_PMS",
    "TECTALIK_PLANNING",
    "TECTALIK_VISITS",
    ...(domain === "eepl" ? ["TECTALIK_FMS"] : []),
  ],
  has_children: domain === "eepl",
  to: domain === "eepl" ? undefined : "/masters_dashboard",
  screen_codeflag: domain === "eepl" ? [...allMaster, ...FMSMaster] : allMaster,
  module_codeflag: ["MASTERS"],
  children: domain === "eepl" ? [
    {
      id: generateRandomString(),
      icon: "mdi-view-dashboard-outline",
      to: "/masters_dashboard",
      name: "Masters Dashboard",
      has_children: false,
      product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS", "TECTALIK_PLANNING", "TECTALIK_VISITS"],
      screen_codeflag: ["SCN_MASTERS_DASHBOARD"],
      module_codeflag: ["MASTERS"],
    },
    {
      id: generateRandomString(),
      name: "FMS",
      child: true,
      screen_code: ["CREATE_MASTERS"],
      product_code: ["TECTALIK_FMS"],
      screen_codeflag: FMSMaster,
      has_children: true,
      has_grand_children: true,
      module_codeflag: ["MASTERS"],
      children: [
        {
          id: generateRandomString(),
          name: "Global",
          icon: "mdi-alpha-g-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Area",            child: true, icon: "mdi-alpha-a-circle", to: "/area_mstr",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_AREA"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Team",            child: true, icon: "mdi-alpha-a-circle", to: "/team",             screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_TEAM"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Expertise Level", child: true, icon: "mdi-alpha-e-circle", to: "/expertise_level",  screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_EXPERTISE_LEVEL"],module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Route",           child: true, icon: "mdi-alpha-r-circle", to: "/route_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ROUTE"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "State",           child: true, icon: "mdi-alpha-s-circle", to: "/state_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_STATE"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Tax",             child: true, icon: "mdi-alpha-t-circle", to: "/tax_mstr",         screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_TAX"],            module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Location",        child: true, icon: "mdi-alpha-l-circle", to: "/location_mstr",    screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_LOCATION"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Branch",          child: true, icon: "mdi-alpha-b-circle", to: "/branch",           screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_BRANCH"],             module_codeflag: ["FMS"] },
          ],
        },
        {
          id: generateRandomString(),
          name: "Lifts",
          icon: "mdi-alpha-l-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Car Operator Make",    child: true, icon: "mdi-alpha-c-circle", to: "/caroprtr_make_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CAR_OPERATOR_MAKE"],   module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Controller",           child: true, icon: "mdi-alpha-c-circle", to: "/controller_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CONTROLLER"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Call Function Type",   child: true, icon: "mdi-alpha-c-circle", to: "/callFunctionType",         screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CALL_FUNCTION_TYPE"],  module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Drive Type",           child: true, icon: "mdi-alpha-d-circle", to: "/drive_type_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_DRIVE_TYPE"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Doordrive Make",       child: true, icon: "mdi-alpha-d-circle", to: "/doordrive_make_mstr",      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_DOORDRIVE_TYPE"],      module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Encoder Model",        child: true, icon: "mdi-alpha-e-circle", to: "/encoder_model_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ENCODER_MODEL"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Encoder Make",         child: true, icon: "mdi-alpha-e-circle", to: "/encoder_make_mstr",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ENCODER_MAKE"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Hoistway Landing Type",child: true, icon: "mdi-alpha-h-circle", to: "/highway_landing_type_mstr",screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_HIGHWAY_LANDING_TYPE"],module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Inverter Make",        child: true, icon: "mdi-alpha-i-circle", to: "/inverter_make_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_INVERTER_MAKE"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Instrument Type",      child: true, icon: "mdi-alpha-i-circle", to: "/instrument_type_mstr",     screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_INSTRUMENT_TYPE"],     module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Lift Category",        child: true, icon: "mdi-alpha-l-circle", to: "/lift_category_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_LIFT_CATEGORY"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Lift Type",            child: true, icon: "mdi-alpha-l-circle", to: "/lift_type_mstr",           screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_LIFT_TYPE"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Lift Make",            child: true, icon: "mdi-alpha-l-circle", to: "/lift_make_mstr",           screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_LIFT_MAKE"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Maindrive Make",       child: true, icon: "mdi-alpha-m-circle", to: "/maindrive_make_mstr",      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MAINDRIVE_MAKE"],      module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Machgear Make",        child: true, icon: "mdi-alpha-m-circle", to: "/machgear_make_mstr",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MACHGEAR_MAKE"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Motor Make",           child: true, icon: "mdi-alpha-m-circle", to: "/motor_make_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MOTOR_MAKE"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Machine Room Position",child: true, icon: "mdi-alpha-m-circle", to: "/machineRoomPosition",      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MACHINE_ROOM"],        module_codeflag: ["FMS"] },
          ],
        },
        {
          id: generateRandomString(),
          name: "Contracts",
          icon: "mdi-alpha-c-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Amc Cancel Category", child: true, icon: "mdi-alpha-a-circle", to: "/amc_cancel_category_mstr",   screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_AMC_CANCEL_CAT"],      module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Amc Type",            child: true, icon: "mdi-alpha-a-circle", to: "/amc_type_mstr",              screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_AMC_TYPE"],            module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Bank",                child: true, icon: "mdi-alpha-b-circle", to: "/bank_mstr",                  screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_BANK"],                module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Cancellation Reason", child: true, icon: "mdi-alpha-c-circle", to: "/reason",                     screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CANCELLATION_REASON"], module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Deductions",          child: true, icon: "mdi-alpha-d-circle", to: "/deduction",                  screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_DEDUCTIONS"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Esclation Time",      child: true, icon: "mdi-alpha-e-circle", to: "/esclation_time_mstr",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ESCLATION_TIME"],      module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Esclation Percentage", child: true, icon: "mdi-alpha-e-circle", to: "/esclation_percentage_mstr", screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ESCLATION_PER"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Payment Type",        child: true, icon: "mdi-alpha-p-circle", to: "/payment_type_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_PAYMENT_TYPE"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Payment Term",        child: true, icon: "mdi-alpha-p-circle", to: "/payment_term_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_PAYMENT_TERM"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Payment Received",    child: true, icon: "mdi-alpha-p-circle", to: "/payment_received_mstr",      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_PAYMENT_RECEIVED"],    module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Policy Type",         child: true, icon: "mdi-alpha-l-circle", to: "/policy_type_mstr",           screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_POLICY_TYPE"],         module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Receipt Mode",        child: true, icon: "mdi-alpha-r-circle", to: "/receipt_mode_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_RECEIPT_MODE"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Receipt Narrations",  child: true, icon: "mdi-alpha-r-circle", to: "/receipt_narrations",         screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_RECEIPT_NARRATIONS"],  module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Reference number Type",child: true,icon: "mdi-alpha-r-circle", to: "/refno_type_mstr",            screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_REFNO_TYPE"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Renewal Type",        child: true, icon: "mdi-alpha-r-circle", to: "/renewal_type_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_RENEWAL_TYPE"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Schedule Visit",      child: true, icon: "mdi-alpha-s-circle", to: "/schedule_visit_mstr",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_SCH_VISIT"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Service",             child: true, icon: "mdi-alpha-s-circle", to: "/fmsservice",                 screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_SERVICE"],             module_codeflag: ["FMS"] },
          ],
        },
        {
          id: generateRandomString(),
          name: "Customer",
          icon: "mdi-alpha-c-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Building Type",         child: true, icon: "mdi-alpha-b-circle", to: "/building_type_mstr",    screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_BUILDING_TYPE"],         module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Customer Type",         child: true, icon: "mdi-alpha-c-circle", to: "/client_type_mstr",      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CLIENT_TYPE"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Customer Subtype",      child: true, icon: "mdi-alpha-c-circle", to: "/client_subtype_mstr",   screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CLIENT_SUBTYPE"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Customer Group",        child: true, icon: "mdi-alpha-c-circle", to: "/customer_group_mstr",   screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CUSTOMER_GROUP"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Customer Designation",  child: true, icon: "mdi-alpha-c-circle", to: "/customer_designation",  screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CUSTOMER_DESIGNATION"],  module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Customer Grade",        child: true, icon: "mdi-alpha-c-circle", to: "/customer_grade_mstr",   screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CUSTOMER_GRADE"],        module_codeflag: ["FMS"] },
          ],
        },
        {
          id: generateRandomString(),
          name: "Material",
          icon: "mdi-alpha-c-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Material",          child: true, icon: "mdi-alpha-m-circle", to: "/material_mstr",    screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MATERIAL"],    module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Spare Parts Group", child: true, icon: "mdi-alpha-s-circle", to: "/spare_parts_master",screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_SPARE_PARTS"], module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Spare Category",    child: true, icon: "mdi-alpha-s-circle", to: "/spare_group_master",screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_SPARE_GROUP"], module_codeflag: ["FMS"] },
          ],
        },
        {
          id: generateRandomString(),
          name: "Tickets",
          icon: "mdi-alpha-t-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Ticket Category",     child: true, icon: "mdi-alpha-t-circle", to: "/ticket_category_mstr",    screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_TICKET_CATEGORY"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Ticket Sub Category", child: true, icon: "mdi-alpha-t-circle", to: "/ticket_subcategory_mstr", screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_TKT_SUBCAT"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Pause Category",      child: true, icon: "mdi-alpha-p-circle", to: "/pause_category",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_PAUSE_CAT"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Customer comment",    child: true, icon: "mdi-alpha-c-circle", to: "/customer_comment",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CUSTOMER_COMMENT"], module_codeflag: ["FMS"] },
          ],
        },
        {
          id: generateRandomString(),
          name: "MR",
          icon: "mdi-alpha-m-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: FMSMaster,
          module_codeflag: ["MASTERS"],
          children: [
            { id: generateRandomString(), name: "Business Center",       child: true, icon: "mdi-alpha-b-circle", to: "/business_centre",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_BUSINESS_CENTER"],        module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Warehouse",             child: true, icon: "mdi-alpha-w-circle", to: "/warehouse_mstr",           screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_WAREHOUSE"],              module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Currency Setting",      child: true, icon: "mdi-alpha-c-circle", to: "/currency_setting",         screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_CURRENCY_SETTING"],       module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Item Category",         child: true, icon: "mdi-alpha-i-circle", to: "/item_category_landing",    screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ITEM_CATEGORY"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Item Classification",   child: true, icon: "mdi-alpha-i-circle", to: "/item_class_landing",       screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ITEM_CLASSIFICATION"],    module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "HS Code",               child: true, icon: "mdi-alpha-h-circle", to: "/hs_code_landing",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_HS_CODE"],                module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "UOM",                   child: true, icon: "mdi-alpha-u-circle", to: "/Uom",                      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_UOM"],                    module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Item Attribute",        child: true, icon: "mdi-alpha-i-circle", to: "/item_attribute_lookup",    screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ITEM_ATTRIBUTE"],         module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Item Attribute Type",   child: true, icon: "mdi-alpha-i-circle", to: "/item_attribute_type",      screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ITEM_ATTRIBUTE_TYPE"],    module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Item type",             child: true, icon: "mdi-alpha-i-circle", to: "/item_type_landing",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ITEM_TYPE"],              module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Item",                  child: true, icon: "mdi-alpha-i-circle", to: "/item_mstr",                screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ITEM"],                   module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Reason For Requirement",child: true, icon: "mdi-alpha-r-circle", to: "/reason_for_requirement",   screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_REASON_FOR_REQUIREMENT"], module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Price Master",          child: true, icon: "mdi-alpha-p-circle", to: "/price_mstr",               screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_PRICE_MASTER"],           module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Vendor Master",         child: true, icon: "mdi-alpha-v-circle", to: "/vendor_mstr",              screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_VENDOR_MASTER"],          module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "MR Type",               child: true, icon: "mdi-alpha-t-circle", to: "/mr_type_landing",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MR_TYPE"],                module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Root Cause Master",     child: true, icon: "mdi-alpha-r-circle", to: "/root_cause_mstr",          screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ROOT_CAUSE_MASTER"],      module_codeflag: ["FMS"] },
            { id: generateRandomString(), name: "Mode of Transport Master",child: true,icon:"mdi-alpha-m-circle", to: "/mode_of_transport_mstr",   screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_MODE_OF_TRANSPORT_MASTER"],module_codeflag:["FMS"] },
            { id: generateRandomString(), name: "Action Taken Master",   child: true, icon: "mdi-alpha-a-circle", to: "/action_taken_mstr",        screen_code: ["CREATE_MASTERS"], product_code: ["TECTALIK_FMS"], screen_codeflag: ["SCN_FMS_ACTION_TAKEN_MASTER"],    module_codeflag: ["FMS"] },
          ],
        },
      ],
    },
  ] : undefined,
},
  {
    id: generateRandomString(),
    name: "Settings",
    icon: require("@/assets/setting-png.png"),
    blue_icon: require("@/assets/blue-settings.png"),
    svg_icon: MenuSvg.Setting_Svg,
    screen_code: ["SCN_SETTINGS"],
    product_code: [
      "TECTALIK_CHCK",
      "TECTALIK_TKT",
      "TECTALIK_PMS",
      "TECTALIK_WLK",
      "TECTALIK_FMS",
    ],
    has_children: false,
    to: "/settings_dashboard",
    screen_codeflag: [
      "SCN_HOLIDAY", "SCN_WEEKOFF", "SCN_ROLE", "SCN_MAIL_CONFIGURATION",
      "SCN_TKT_CMP_SLAB", "SCN_EMP_FIELD_RIGHTS", "SCN_COMMON_SETTINGS",
      "SCN_USERS", "SCN_PASSWORD_PORTAL",
      "SCN_PMS_RATING_SETTING", "SCN_PMS_PRFMNC_RATING_SETTING", "SCN_SCORECARD_SETTING",
      "SCN_PMS_EMPLOYEE_DASHBOARD", "SCN_PMS_CEO_DASH",
      "SCN_WLKN_FEEDBACK", "SCN_WLKN_SALESMAN_SETTING", "SCN_WLKN_MANAGER_SETTING",
      "SCN_FMS_POLICY_DEF", "SCN_FMS_TICKET_DEF", "SCN_FMS_APPROVAL_LIST",
      "SCN_FMS_DASHBOARD_ROLES", "SCN_FMS_DASHBOARD", "SCN_FMS_TERMS",
      "SCN_LIBRARY", "SCN_COMMON_ANALYTICS", "SCN_CLIENT_BILLING",
    ],
    module_codeflag: ["SETTINGS"],
  },
  {
    id: generateRandomString(),
    name: "Drona AI",
    svg_icon: MenuSvg.Drona_Svg,
    has_children: false,
    to: "/ai_dashboard",
    screen_code: ["SCN_DRONA"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_DRONA"],
    module_codeflag: ["DRONA_AI"],
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "FMS",
    svg_icon: MenuSvg.FMS_Svg,
    has_children: true,
    sub_children: true,
    has_grand_children: false,
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_FMS"],
    screen_codeflag: ["SCN_FMS"],
    module_codeflag: ["FMS"],
    product_gate: true,
    product_only: true,
    children: [
      {
        id: generateRandomString(),
        icon: "mdi-alpha-c-box",
        name: "Customer",
        to: "/customer_dtl",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_CUSTOMER"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-b-box",
        to: "/building",
        name: "Building",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_BUILDING"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-l-box",
        name: "Lift",
        to: "/lift",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_LIFT"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-c-box",
        name: "Contract",
        to: "/Contract",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_CONTRACT"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-q-box",
        name: "Quotation",
        to: "/Quotation",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_QUOTATION"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-r-box",
        name: "Receipt",
        to: "/receipt",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_RECEIPT"],
        module_codeflag: ["FMS"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-b-box",
        name: "Billing",
        to: "/billing",
        screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_BILLING"],
        module_codeflag: ["FMS"],
      },
    ],
  },
  {
    id: generateRandomString(),
    name: "",
    icon: "",
    has_children: true,
    sub_children: true,
    has_grand_children: false,
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_FMS"],
    screen_codeflag: ["SCN_FMS"],
    module_codeflag: ["FMS"],
    product_gate: true,
    product_only: true,
    children: [
      {
        id: generateRandomString(),
        name: "Tickets",
        icon: "mdi-alpha-t-circle",
        child: true,
        has_children: true,
        grouping_children: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_TICKETS"],
        module_codeflag: ["FMS"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-alpha-t-box",
            name: "Tickets",
            to: "/fms/tickets",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TICKETS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "Scheduled Tickets",
            child: true,
            icon: "mdi-alpha-s-box",
            to: "/scheduled_tickets",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_SCHEDULED_TICKETS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "Scheduled Tickets Count",
            child: true,
            icon: "mdi-alpha-s-box",
            to: "/scheduled_tickets_count",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_SCHEDULED_TICKETS_COUNT"],
            module_codeflag: ["FMS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "MR",
        icon: "mdi-alpha-m-circle",
        child: true,
        has_children: true,
        grouping_children: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: [
          "SCN_FMS_MR",
          "SCN_FMS_MR_QUOTATION",
          "SCN_FMS_MR_CONTRACT",
          "SCN_FMS_TRANSFER",
          "SCN_FMS_MR_GRN",
          "SCN_FMS_MR_RECEIPT_STATUS",
        ],
        module_codeflag: ["FMS"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-alpha-m-box",
            name: "MR",
            to: "/mr_landing",
            screen_code: ["CREATE_MASTERS"],
            child: true,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_MR"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "MR Quotation",
            child: true,
            icon: "mdi-alpha-m-box",
            to: "/MrQuotation",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_MR_QUOTATION"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "MR Contract",
            child: true,
            icon: "mdi-alpha-m-box",
            to: "/MrContract",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_MR_CONTRACT"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "Transfer",
            child: true,
            icon: "mdi-alpha-t-box",
            to: "/transfer_landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TRANSFER"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "GRN",
            child: true,
            icon: "mdi-alpha-g-box",
            to: "/grn_landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_MR_GRN"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "Faulty Material Received Status",
            child: true,
            icon: "mdi-alpha-m-box",
            to: "/mr_receipt_status_landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_FAULTY_MATERIAL_STATUS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "Stock Ledger",
            child: true,
            icon: "mdi-alpha-s-box",
            to: "/mr_stock_ledger",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_MR_STOCK_LEDGER"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            name: "MR Receipt",
            child: true,
            icon: "mdi-alpha-m-box",
            to: "/mr_receipt_landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_MR_RECEIPT"],
            module_codeflag: ["FMS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "TIS",
        icon: "mdi-alpha-t-circle",
        child: true,
        has_children: true,
        has_grand_children: true,
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: ["SCN_FMS_TIS"],
        module_codeflag: ["FMS"],
        children: [
          {
            id: generateRandomString(),
            name: "TIS",
            icon: "mdi-alpha-t-circle",
            child: true,
            has_children: true,
            grouping_children: true,
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TIS"],
            module_codeflag: ["FMS"],
            children: [
              {
                id: generateRandomString(),
                icon: "mdi-alpha-t-box",
                name: "TIS",
                to: "/tis_landing",
                screen_code: ["CREATE_MASTERS"],
                child: true,
                product_code: ["TECTALIK_FMS"],
                screen_codeflag: ["SCN_FMS_TIS"],
                module_codeflag: ["FMS"],
              },
            ],
          },
          {
            id: generateRandomString(),
            name: "TIS Survey",
            icon: "mdi-alpha-t-circle",
            child: true,
            has_children: true,
            grouping_children: true,
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TIS_SURVEY"],
            module_codeflag: ["FMS"],
            children: [
              {
                id: generateRandomString(),
                icon: "mdi-alpha-t-box",
                name: "TIS Survey Group",
                to: "/tis_survey_group",
                screen_code: ["CREATE_MASTERS"],
                child: true,
                product_code: ["TECTALIK_FMS"],
                screen_codeflag: ["SCN_FMS_TIS_SURVEY_GROUP"],
                module_codeflag: ["FMS"],
              },
              {
                id: generateRandomString(),
                icon: "mdi-alpha-t-box",
                name: "TIS Survey Field",
                to: "/tis_survey_field",
                screen_code: ["CREATE_MASTERS"],
                child: true,
                product_code: ["TECTALIK_FMS"],
                screen_codeflag: ["SCN_FMS_TIS_SURVEY_FIELD"],
                module_codeflag: ["FMS"],
              },
              {
                id: generateRandomString(),
                icon: "mdi-alpha-t-box",
                name: "TIS Survey Type",
                to: "/tis_survey_type",
                screen_code: ["CREATE_MASTERS"],
                child: true,
                product_code: ["TECTALIK_FMS"],
                screen_codeflag: ["SCN_FMS_TIS_SURVEY_TYPE"],
                module_codeflag: ["FMS"],
              },
              {
                id: generateRandomString(),
                icon: "mdi-alpha-t-box",
                name: "TIS Survey Value",
                to: "/tis_survey_value",
                screen_code: ["CREATE_MASTERS"],
                child: true,
                product_code: ["TECTALIK_FMS"],
                screen_codeflag: ["SCN_FMS_TIS_SURVEY_VALUE"],
                module_codeflag: ["FMS"],
              },
            ],
          },
        ],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-j-box",
        name: "Job History",
        screen_code: ["CREATE_MASTERS"],
        has_children: true,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: [
          "SCN_FMS_ATT_LOOKUP_GROUP",
          "SCN_FMS_ATT_LOOKUP_TYPE",
          "SCN_FMS_ATT_LOOKUP",
        ],
        module_codeflag: ["FMS"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-alpha-a-box",
            name: "Attribute Lookup Group",
            to: "/attribute_lookup_group",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_ATT_LOOKUP_GROUP"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-a-box",
            name: "Attribute Lookup Type",
            to: "/attribute_lookup_type",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_ATT_LOOKUP_TYPE"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-a-box",
            name: "Attribute Lookup",
            to: "/attribute_lookup",
            screen_code: ["CREATE_MASTERS"],
            sub_children: true,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_ATT_LOOKUP"],
            module_codeflag: ["FMS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-r-box",
        name: "Reports",
        screen_code: ["CREATE_MASTERS"],
        has_children: true,
        product_code: ["TECTALIK_FMS"],
        screen_codeflag: [
          "SCN_FMS_TECHNICAL_CHART",
          "SCN_FMS_OUTSTANDING_REPORT",
          "SCN_FMS_LIFT_REPORTS",
          "SCN_FMS_BUILDING_TICKET_REPORTS",
          "SCN_FMS_ATTENDANCE_REPORTS",
          "SCN_FMS_DAILY_ATTENDANCE_REPORTS",
          "SCN_FMS_PREVENTIVE_MAINTENANCE_REPORTS",
          "SCN_FMS_RECEIPT_BOOKING_STATUS_REPORTS",
          "SCN_FMS_AMC_NOT_RENEWED_REPORTS",
          "SCN_FMS_CURRENT_MONTH_AMC_RENEWAL_REPORTS",
          "SCN_FMS_ADVANCE_AMC_RENEWAL_REPORTS",
          "SCN_FMS_CANCELLED_CONTRACT_REPORTS",
          "SCN_FMS_AMC_COLLECTION_REPORTS",
          "SCN_FMS_CONTRACT_LIFT_SUMMARY_REPORTS",
          "SCN_FMS_CLOSE_MONITORING_REPORTS",
          "SCN_FMS_DASHBOARD_REPORTS"
        ],
        module_codeflag: ["FMS"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-alpha-t-box",
            name: "Technical Chart",
            to: "/reports/technical_chart",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TECHNICAL_CHART"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-o-box",
            name: "Outstanding",
            to: "/reports/outstanding",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_OUTSTANDING_REPORT"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-l-box",
            name: "lift reports",
            to: "/reports/lift_reports",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_LIFT_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-b-box",
            name: "Building Ticket Reports",
            to: "/reports/building_ticket_reports",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_BUILDING_TICKET_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-a-box",
            name: "Attendance Reports",
            to: "/reports/attendance_reports",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_ATTENDANCE_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-d-box",
            name: "Daily Attendance Reports",
            to: "/reports/daily_attendance_reports",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_DAILY_ATTENDANCE_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-p-box",
            name: "Preventive Maintenance Reports",
            to: "/reports/preventive_maintenance_reports_mv",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_PREVENTIVE_MAINTENANCE_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-r-box",
            name: "Receipt Booking Status Reports",
            to: "/reports/receipt_booking_status_reports",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_RECEIPT_BOOKING_STATUS_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-n-box",
            name: "Not Renewed List",
            to: "/reports/amc_not_renewed_reports_mv",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_AMC_NOT_RENEWED_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Current Month Renewal List",
            to: "/reports/current_month_amc_renewal_reports_mv",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_CURRENT_MONTH_AMC_RENEWAL_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-a-box",
            name: "Advance Renewal List",
            to: "/reports/advance_amc_renewal_reports_mv",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_ADVANCE_AMC_RENEWAL_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Cancelled Contract Report",
            to: "/reports/cancelled_contract_reports",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_CANCELLED_CONTRACT_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Amc Collection Report",
            to: "/reports/amc_collection_report",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_AMC_COLLECTION_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Contract Lift Summary Report",
            to: "/reports/contract_lift_report",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_CONTRACT_LIFT_SUMMARY_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Close Monitoring Report",
            to: "/reports/close_monitoring_report",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_CLOSE_MONITORING_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-t-box",
            name: "Ticket Ageing Report",
            to: "/reports/ticket_ageing_report_mv",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TICKET_AGEING_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-d-box",
            name: "Dashboard Reports",
            to: "/reports/dashboard",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_DASHBOARD_REPORTS"],
            module_codeflag: ["FMS"],
          },
        ],
      },
    ],
  },
];
let FullSideMENU = [
  { ...Strategy_OBJ },
  { ...Team_OBJ },
  {
    id: generateRandomString(),
    name: "Act",
    svg_icon: MenuSvg.Flash_Svg,
    icon: require("@/assets/act-png.png"),
    blue_icon: require("@/assets/blue-act.png"),
    product_code: [
      "TECTALIK_CHCK",
      "TECTALIK_TKT",
      "TECTALIK_SURVEY",
      "TECTALIK_VISITS",
      "TECTALIK_WLK",
    ],
    has_children: true,
    screen_codeflag: All_Act,
    module_codeflag: ["RACI", "SOP", "DOA", "POLICIES", "WORK_FLOW", "FORMS", "PROJECTS", "CRM", "WALKIN", "VISITS", "TICKETS", "CHECKLIST", "DMS", "SURVEY"],
    is_FirstLetter: true,
    children: [...ACT_Child_ARR_1, ...ACT_Child_ARR_2],
  },
  { ...Review_OBJ },
  { ...Reward_OBJ },
  {
    id: generateRandomString(),
    name: "Masters",
    icon: require("@/assets/masters-png.png"),
    blue_icon: require("@/assets/blue-masters.png"),
    svg_icon: MenuSvg._3DCube_Svg,
    screen_code: ["CREATE_MASTERS"],
    product_code: [
      "TECTALIK_CHCK",
      "TECTALIK_TKT",
      "TECTALIK_PMS",
      "TECTALIK_PLANNING",
      "TECTALIK_VISITS",
    ],
    has_children: false,
    to: "/masters_dashboard",
    screen_codeflag: allMaster,
    module_codeflag: ["MASTERS"],
  },
  // Admin-portal-only "Masters" group (separate from the tenant Masters link
  // above — iscommontoshow makes this visible only on the admin/devadmin
  // domain, so it never affects the regular tenant Masters navigation).
  {
    id: generateRandomString(),
    name: "Masters",
    icon: require("@/assets/masters-png.png"),
    blue_icon: require("@/assets/blue-masters.png"),
    svg_icon: MenuSvg._3DCube_Svg,
    has_children: true,
    product_code: [],
    screen_codeflag: [],
    module_codeflag: [],
    iscommontoshow: true,
    children: [
      {
        id: generateRandomString(),
        name: "Clients",
        icon: "mdi-domain",
        to: "/client",
        has_children: false,
        product_code: [],
        screen_codeflag: [],
        module_codeflag: [],
        iscommontoshow: true,
      },
    ],
  },
  {
    id: generateRandomString(),
    name: "Settings",
    child: true,
    icon: require("@/assets/setting-png.png"),
    blue_icon: require("@/assets/blue-settings.png"),
    svg_icon: MenuSvg.Setting_Svg,
    screen_code: ["CREATE_MASTERS"],
    product_code: [
      "TECTALIK_CHCK",
      "TECTALIK_TKT",
      "TECTALIK_PMS",
      "TECTALIK_WLK",
      "TECTALIK_FMS",
    ],
    has_children: false,
    to: "/settings_dashboard",
    screen_codeflag: [
      "SCN_HOLIDAY",
      "SCN_WEEKOFF",
      "SCN_ROLE",
      "SCN_SCENARIOS",
      "SCN_MAIL_CONFIGURATION",
      "SCN_WLKN_SALESMAN_SETTING",
      "SCN_WLKN_MANAGER_SETTING",
      "SCN_WLKN_FEEDBACK",
      "SCN_TKT_CMP_SLAB",
      "SCN_PMS_RATING_SETTING",
      "SCN_PMS_PRFMNC_RATING_SETTING",
      "SCN_PMS_EMPLOYEE_DASHBOARD",
      "SCN_CLIENT_BILLING"
    ],
    module_codeflag: ["SETTINGS"],
  },
  {
      id: generateRandomString(),
      name: "FMS",
      svg_icon: MenuSvg.FMS_Svg,
      has_children: true,
      sub_children: true,
      has_grand_children: false,
      screen_code: ["CREATE_MASTERS"],
      product_code: ["TECTALIK_FMS"],
      screen_codeflag: ["SCN_FMS"],
      module_codeflag: ["FMS"],
      children: [
        {
          id: generateRandomString(),
          icon: "mdi-alpha-c-box",
          name: "Customer",
          to: "/customer_dtl",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_CUSTOMER"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-b-box",
          to: "/building",
          name: "Building",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_BUILDING"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-l-box",
          name: "Lift",
          to: "/lift",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_LIFT"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-c-box",
          name: "Contract",
          to: "/Contract",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_CONTRACT"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-q-box",
          name: "Quotation",
          to: "/Quotation",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_QUOTATION"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-r-box",
          name: "Receipt",
          to: "/receipt",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_RECEIPT"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-b-box",
          name: "Billing",
          to: "/billing",
          screen_code: ["CREATE_MASTERS"],
          has_children: false,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_BILLING"],
          module_codeflag: ["FMS"],
        },
        {
          id: generateRandomString(),
          name: "Tickets",
          icon: "mdi-alpha-t-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_TICKETS"],
          module_codeflag: ["FMS"],
          children: [
            {
              id: generateRandomString(),
              icon: "mdi-alpha-t-box",
              name: "Tickets",
              to: "/fms/tickets",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_TICKETS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "Scheduled Tickets",
              child: true,
              icon: "mdi-alpha-s-box",
              to: "/scheduled_tickets",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_SCHEDULED_TICKETS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "Scheduled Tickets Count",
              child: true,
              icon: "mdi-alpha-s-box",
              to: "/scheduled_tickets_count",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_SCHEDULED_TICKETS_COUNT"],
              module_codeflag: ["FMS"],
            },
          ],
        },
        {
          id: generateRandomString(),
          name: "MR",
          icon: "mdi-alpha-m-circle",
          child: true,
          has_children: true,
          grouping_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: [
            "SCN_FMS_MR",
            "SCN_FMS_MR_QUOTATION",
            "SCN_FMS_MR_CONTRACT",
            "SCN_FMS_TRANSFER",
            "SCN_FMS_MR_GRN",
            "SCN_FMS_MR_RECEIPT_STATUS",
          ],
          module_codeflag: ["FMS"],
          children: [
            {
              id: generateRandomString(),
              icon: "mdi-alpha-m-box",
              name: "MR",
              to: "/mr_landing",
              screen_code: ["CREATE_MASTERS"],
              child: true,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_MR"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "MR Quotation",
              child: true,
              icon: "mdi-alpha-m-box",
              to: "/MrQuotation",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_MR_QUOTATION"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "MR Contract",
              child: true,
              icon: "mdi-alpha-m-box",
              to: "/MrContract",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_MR_CONTRACT"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "Transfer",
              child: true,
              icon: "mdi-alpha-t-box",
              to: "/transfer_landing",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_TRANSFER"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "GRN",
              child: true,
              icon: "mdi-alpha-g-box",
              to: "/grn_landing",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_MR_GRN"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "Faulty Material Received Status",
              child: true,
              icon: "mdi-alpha-m-box",
              to: "/mr_receipt_status_landing",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_FAULTY_MATERIAL_STATUS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "Stock Ledger",
              child: true,
              icon: "mdi-alpha-s-box",
              to: "/mr_stock_ledger",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_MR_STOCK_LEDGER"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              name: "MR Receipt",
              child: true,
              icon: "mdi-alpha-m-box",
              to: "/mr_receipt_landing",
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_MR_RECEIPT"],
              module_codeflag: ["FMS"],
            },
          ],
        },
        {
          id: generateRandomString(),
          name: "TIS",
          icon: "mdi-alpha-t-circle",
          child: true,
          has_children: true,
          has_grand_children: true,
          screen_code: ["CREATE_MASTERS"],
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: ["SCN_FMS_TIS"],
          module_codeflag: ["FMS"],
          children: [
            {
              id: generateRandomString(),
              name: "TIS",
              icon: "mdi-alpha-t-circle",
              child: true,
              has_children: true,
              grouping_children: true,
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_TIS"],
              module_codeflag: ["FMS"],
              children: [
                {
                  id: generateRandomString(),
                  icon: "mdi-alpha-t-box",
                  name: "TIS",
                  to: "/tis_landing",
                  screen_code: ["CREATE_MASTERS"],
                  child: true,
                  product_code: ["TECTALIK_FMS"],
                  screen_codeflag: ["SCN_FMS_TIS"],
                  module_codeflag: ["FMS"],
                },
              ],
            },
            {
              id: generateRandomString(),
              name: "TIS Survey",
              icon: "mdi-alpha-t-circle",
              child: true,
              has_children: true,
              grouping_children: true,
              screen_code: ["CREATE_MASTERS"],
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_TIS_SURVEY"],
              module_codeflag: ["FMS"],
              children: [
                {
                  id: generateRandomString(),
                  icon: "mdi-alpha-t-box",
                  name: "TIS Survey Group",
                  to: "/tis_survey_group",
                  screen_code: ["CREATE_MASTERS"],
                  child: true,
                  product_code: ["TECTALIK_FMS"],
                  screen_codeflag: ["SCN_FMS_TIS_SURVEY_GROUP"],
                  module_codeflag: ["FMS"],
                },
                {
                  id: generateRandomString(),
                  icon: "mdi-alpha-t-box",
                  name: "TIS Survey Field",
                  to: "/tis_survey_field",
                  screen_code: ["CREATE_MASTERS"],
                  child: true,
                  product_code: ["TECTALIK_FMS"],
                  screen_codeflag: ["SCN_FMS_TIS_SURVEY_FIELD"],
                  module_codeflag: ["FMS"],
                },
                {
                  id: generateRandomString(),
                  icon: "mdi-alpha-t-box",
                  name: "TIS Survey Type",
                  to: "/tis_survey_type",
                  screen_code: ["CREATE_MASTERS"],
                  child: true,
                  product_code: ["TECTALIK_FMS"],
                  screen_codeflag: ["SCN_FMS_TIS_SURVEY_TYPE"],
                  module_codeflag: ["FMS"],
                },
                {
                  id: generateRandomString(),
                  icon: "mdi-alpha-t-box",
                  name: "TIS Survey Value",
                  to: "/tis_survey_value",
                  screen_code: ["CREATE_MASTERS"],
                  child: true,
                  product_code: ["TECTALIK_FMS"],
                  screen_codeflag: ["SCN_FMS_TIS_SURVEY_VALUE"],
                  module_codeflag: ["FMS"],
                },
              ],
            },
          ],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-j-box",
          name: "Job History",
          screen_code: ["CREATE_MASTERS"],
          has_children: true,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: [
            "SCN_FMS_ATT_LOOKUP_GROUP",
            "SCN_FMS_ATT_LOOKUP_TYPE",
            "SCN_FMS_ATT_LOOKUP",
          ],
          module_codeflag: ["FMS"],
          children: [
            {
              id: generateRandomString(),
              icon: "mdi-alpha-a-box",
              name: "Attribute Lookup Group",
              to: "/attribute_lookup_group",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_ATT_LOOKUP_GROUP"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-a-box",
              name: "Attribute Lookup Type",
              to: "/attribute_lookup_type",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_ATT_LOOKUP_TYPE"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-a-box",
              name: "Attribute Lookup",
              to: "/attribute_lookup",
              screen_code: ["CREATE_MASTERS"],
              sub_children: true,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_ATT_LOOKUP"],
              module_codeflag: ["FMS"],
            },
          ],
        },
        {
          id: generateRandomString(),
          icon: "mdi-alpha-r-box",
          name: "Reports",
          screen_code: ["CREATE_MASTERS"],
          has_children: true,
          product_code: ["TECTALIK_FMS"],
          screen_codeflag: [
            "SCN_FMS_TECHNICAL_CHART",
            "SCN_FMS_OUTSTANDING_REPORT",
            "SCN_FMS_LIFT_REPORTS",
            "SCN_FMS_BUILDING_TICKET_REPORTS",
            "SCN_FMS_ATTENDANCE_REPORTS",
            "SCN_FMS_DAILY_ATTENDANCE_REPORTS",
            "SCN_FMS_PREVENTIVE_MAINTENANCE_REPORTS",
            "SCN_FMS_RECEIPT_BOOKING_STATUS_REPORTS",
            "SCN_FMS_AMC_NOT_RENEWED_REPORTS",
            "SCN_FMS_CURRENT_MONTH_AMC_RENEWAL_REPORTS",
            "SCN_FMS_ADVANCE_AMC_RENEWAL_REPORTS",
            "SCN_FMS_CANCELLED_CONTRACT_REPORTS",
            "SCN_FMS_AMC_COLLECTION_REPORTS",
            "SCN_FMS_CONTRACT_LIFT_SUMMARY_REPORTS",
            "SCN_FMS_CLOSE_MONITORING_REPORTS",
            "SCN_FMS_DASHBOARD_REPORTS"
          ],
          module_codeflag: ["FMS"],
          children: [
            {
              id: generateRandomString(),
              icon: "mdi-alpha-t-box",
              name: "Technical Chart",
              to: "/reports/technical_chart",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_TECHNICAL_CHART"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-o-box",
              name: "Outstanding",
              to: "/reports/outstanding",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_OUTSTANDING_REPORT"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-l-box",
              name: "lift reports",
              to: "/reports/lift_reports",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_LIFT_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-b-box",
              name: "Building Ticket Reports",
              to: "/reports/building_ticket_reports",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_BUILDING_TICKET_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-a-box",
              name: "Attendance Reports",
              to: "/reports/attendance_reports",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_ATTENDANCE_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-d-box",
              name: "Daily Attendance Reports",
              to: "/reports/daily_attendance_reports",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_DAILY_ATTENDANCE_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-p-box",
              name: "Preventive Maintenance Reports",
              to: "/reports/preventive_maintenance_reports_mv",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_PREVENTIVE_MAINTENANCE_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-r-box",
              name: "Receipt Booking Status Reports",
              to: "/reports/receipt_booking_status_reports",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_RECEIPT_BOOKING_STATUS_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-n-box",
              name: "Not Renewed List",
              to: "/reports/amc_not_renewed_reports_mv",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_AMC_NOT_RENEWED_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-c-box",
              name: "Current Month Renewal List",
              to: "/reports/current_month_amc_renewal_reports_mv",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_CURRENT_MONTH_AMC_RENEWAL_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-a-box",
              name: "Advance Renewal List",
              to: "/reports/advance_amc_renewal_reports_mv",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_ADVANCE_AMC_RENEWAL_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-c-box",
              name: "Cancelled Contract Report",
              to: "/reports/cancelled_contract_reports",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_CANCELLED_CONTRACT_REPORTS"],
              module_codeflag: ["FMS"],
            },
            {
              id: generateRandomString(),
              icon: "mdi-alpha-c-box",
              name: "Amc Collection Report",
              to: "/reports/amc_collection_report",
              screen_code: ["CREATE_MASTERS"],
              has_children: false,
              product_code: ["TECTALIK_FMS"],
              screen_codeflag: ["SCN_FMS_AMC_COLLECTION_REPORTS"],
              module_codeflag: ["FMS"],
            },
             {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Contract Lift Summary Report",
            to: "/reports/contract_lift_report",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_CONTRACT_LIFT_SUMMARY_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-c-box",
            name: "Close Monitoring Report",
            to: "/reports/close_monitoring_report",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_CLOSE_MONITORING_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-t-box",
            name: "Ticket Ageing Report",
            to: "/reports/ticket_ageing_report_mv",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_TICKET_AGEING_REPORTS"],
            module_codeflag: ["FMS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-d-box",
            name: "Dashboard Reports",
            to: "/reports/dashboard",
            screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_FMS"],
            screen_codeflag: ["SCN_FMS_DASHBOARD_REPORTS"],
            module_codeflag: ["FMS"],
          },
          ],
        },
      ],
  },
  {
    id: generateRandomString(),
    name: "Set Up STARR",
    icon: "mdi-rocket-launch-outline",
    has_children: false,
    to: "/setup_guide",
    screen_code: ["SCN_STARR_SETUP"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_STARR_SETUP"],
    module_codeflag: ["COMMON"],
    iscommontoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Content Hub",
    icon: "mdi-newspaper-variant-outline",
    has_children: false,
    to: "/content_hub",
    screen_code: ["SCN_CONTENT_HUB"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_CONTENT_HUB"],
    module_codeflag: ["COMMON"],
    iscommontoshow: true,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "SEO & Social",
    icon: "mdi-chart-timeline-variant-shimmer",
    has_children: false,
    to: "/seo_sm_manager",
    screen_code: ["SCN_SEO_SOCIAL"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_SEO_SOCIAL"],
    module_codeflag: ["COMMON"],
    iscommontoshow: true,
  },

  {
    id: generateRandomString(),
    name: "Partner Dashboard",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    // NOTE (20260823142011): Points at V2.
    // Both versions render the same behaviour from partner_dashboard.logic.js
    // and both now use the shared ClientForm, so this is a presentation swap
    // rather than a functional one. V1 stays reachable at /partner_landing
    // until it is retired.
    to: "/partner_landing_v2",
    screen_code: ["SCN_PARTNER_DASHBOARD"],
    product_code: [],
    screen_codeflag: ["SCN_PARTNER_DASHBOARD"],
    module_codeflag: [],
  },
  {
    id: generateRandomString(),
    name: "Partner Commission",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/partner_commission",
    screen_code: ["SCN_PARTNER_COMMISSION"],
    product_code: [],
    screen_codeflag: ["SCN_PARTNER_COMMISSION"],
    module_codeflag: [],
  },
  {
    id: generateRandomString(),
    name: "Partner Approvals",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/partner_approvals",
    screen_code: ["SCN_PARTNER_APPROVALS"],
    product_code: [],
    screen_codeflag: ["SCN_PARTNER_APPROVALS"],
    module_codeflag: [],
    iscommontoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Billing & Collections",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/billing_admin",
    screen_code: ["SCN_BILLING_ADMIN"],
    product_code: [],
    screen_codeflag: ["SCN_BILLING_ADMIN"],
    module_codeflag: [],
  },
  {
    id: generateRandomString(),
    name: "Billing Report",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/billing_report",
    screen_code: ["SCN_BILLING_REPORT"],
    product_code: [],
    screen_codeflag: ["SCN_BILLING_REPORT"],
    module_codeflag: [],
  },
  {
    id: generateRandomString(),
    name: "Marketplace",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/marketplace",
    screen_code: ["SCN_MARKETPLACE"],
    product_code: [],
    screen_codeflag: ["SCN_MARKETPLACE"],
    module_codeflag: [],
  },
  {
    id: generateRandomString(),
    name: "Workshop",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/workshop-admin",
    screen_code: ["SCN_WORKSHOP_ADMIN"],
    product_code: [],
    screen_codeflag: ["SCN_WORKSHOP_ADMIN"],
    module_codeflag: [],
  },
  {
    // Facilitator availability calendar. A partner sees their own; an admin
    // holding this screen right picks the partner. Needs the
    // SCN_PARTNER_WORKSHOP_CALENDAR screen row + role rights to appear.
    id: generateRandomString(),
    name: "Workshop Calendar",
    svg_icon: MenuSvg.DashBoard_SVG,
    icon: require("@/assets/dashboardnew.png"),
    blue_icon: require("@/assets/blue-dashboard.png"),
    has_children: false,
    to: "/partner_workshop_calendar",
    screen_code: ["SCN_PARTNER_WORKSHOP_CALENDAR"],
    product_code: [],
    screen_codeflag: ["SCN_PARTNER_WORKSHOP_CALENDAR"],
    module_codeflag: [],
  },
];
const _STARR_MENU_ = {
  TopMenuList,
  BottonLeftMenuList,
  BottonRightMenuList,
  FullSideMENU,
};
module.exports = _STARR_MENU_;
